import api from "./axios";

export const getMyNotifications = (range = "week") =>
  api.get("/notifications", { params: { range } });

export const markNotificationRead = (notificationId) =>
  api.put(`/notifications/${notificationId}/read`);

export const markAllNotificationsRead = () =>
  api.put("/notifications/read-all");
